// extracted by mini-css-extract-plugin
module.exports = {"adminDeliveryCategories":"AdminDeliveryCategories_adminDeliveryCategories__olCKm","errorMessage":"AdminDeliveryCategories_errorMessage__3S7GR"};